export const ratingPath = '/rating'
export const matchCouplePath = '/match-couple'
export const ratingLegacyMatchPath = '/match'
